export const LIFETIME = 'L';
export const COMPED = 'C';
export const NORMAL = 'N';
